<template lang="pug">
b-modal#bankAdjust(
  ref="bankAdjust"
  :title="$t('ui.combine.bank_adjust')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.banks', 1)" disabled).mb-0
      BankLookup(
        ref="bank"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    b-form-group(:label="$t('ui.bank_acc_no')" disabled).mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        :dirty="$v.bank_acc_no.$dirty"
        :error="$v.bank_acc_no.$error"
        v-model.trim.lazy="$v.bank_acc_no.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
    b-form-group(:label="$tc('ui.bank_acc_holder')" disabled).mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        :dirty="$v.bank_acc_holder.$dirty"
        :error="$v.bank_acc_holder.$error"
        v-model.trim.lazy="$v.bank_acc_holder.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_holder" :name="$t('ui.bank_acc_holder')")
    b-form-group(:label="$t('ui.account_balance')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="account_balance"
        type="text"
        :dirty="$v.account_balance.$dirty"
        :error="$v.account_balance.$error"
        v-model.trim.lazy="$v.account_balance.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.account_balance" :name="$t('ui.account_balance')")
    b-form-group(:label="$t('ui.adj_amount')").mb-0
      DebounceInput(
        size="sm"
        ref="adj_amount"
        type="text"
        :dirty="$v.adj_amount.$dirty"
        :error="$v.adj_amount.$error"
        v-model.trim.lazy="$v.adj_amount.$model"
        :disabled="loading"
      )
      span.small.text-info {{ $t('message.adjust_amount_bank_tooltip') }}
      ValidateResult(:value="$v.adj_amount" :name="$t('ui.adj_amount')")
    div.row
      div.col-12
        b-form-group(:label="$tc('ui.remark')").mb-0
          DebounceInput(
            size="sm"
            type="text"
            v-model="remark"
            :disabled="loading"
          )
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      bank: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      remark: "",
      account_balance: "",
      adj_amount: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    bank: {
      required
    },
    bank_acc_no: {
      required,
      // integer,
      // minLength: minLength(6),
      // maxLength: maxLength(20)
    },
    bank_acc_holder: {
      required,
      // alphaNumWithSpace,
      // minLength: minLength(6),
      // maxLength: maxLength(50)
    },
    account_balance: {
      required,
      decimal
    },
    adj_amount: {
      required,
      decimal
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankAdjustUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          bank_id: this.bank.split(' - ')[0].trim(),
          bank_acc_no: this.bank_acc_no.trim(),
          amount: this.adj_amount,
          remark: this.remark,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.bankAdjust.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "adjust_balance", this.feedback.status);
                  this.$refs.bankAdjust.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {

      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.bank = (this.item.bank_id + ' - ' + this.item.bank_name).toUpperCase();
      this.bank_acc_no = this.item.bank_acc_no;
      this.bank_acc_holder = this.item.bank_acc_holder;
      this.account_balance = this.item.account_balance;
      this.adj_amount = "";
      this.remark = "";
      this.$refs.adj_amount.$el.focus();
    }
  }
};
</script>
